import { useEffect } from "react";
import { $generateNodesFromDOM } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $insertNodes, $setSelection } from "lexical";

type LoadDefaultValuesProps = { defaultValues: string };

const textHtmlMimeType = "text/html";

const LoadDefaultValues = ({ defaultValues }: LoadDefaultValuesProps) => {
	const [editor] = useLexicalComposerContext();

	useEffect(() => {
		if (!defaultValues) {
			return;
		}
		editor.update(() => {
			// In the browser you can use the native DOMParser API to parse the HTML string.
			const parser = new DOMParser();
			const dom = parser.parseFromString(defaultValues, textHtmlMimeType);

			// Once you have the DOM instance it's easy to generate LexicalNodes.
			const nodes = $generateNodesFromDOM(editor, dom);

			// Select the root
			$getRoot().select();

			// Insert them at a selection.
			$insertNodes(nodes);

			// Remove focus from Editor input
			$setSelection(null);
		});
	}, [defaultValues, editor]);

	return null;
};

export default LoadDefaultValues;
